let userLang = JSON.parse(window.localStorage.getItem("userLangDetail"));
export const getLocalStorage = () => {
  userLang = JSON.parse(window.localStorage.getItem("userLangDetail"));
  HeaderData = {
    columns: [
      {
        label: userLang?.common?.STATUS,
        field: "status",
        sort: "asc",
        width: 1,
      },
      {
        label: userLang?.report?.NO_OF_INDENT,
        field: "indentNo",
        sort: "asc",
        width: 1,
      },
    ],
  };
};
if (localStorage.getItem("userLangDetail") === null) {
  getLocalStorage();
}
export var HeaderData = {
  columns: [
    {
      label: userLang?.common?.STATUS,
      field: "status",
      sort: "asc",
      width: 1,
    },
    {
      label: userLang?.report?.NO_OF_INDENT,
      field: "indentNo",
      sort: "asc",
      width: 1,
    },
  ],
};
export const searchBar = {
  searchBarData: [
    {
      label: userLang?.common?.STATUS,
      field: "status",
      sort: "asc",
      width: 1,
    },
    {
      label: userLang?.report?.NO_OF_INDENT,
      field: "IndentNo",
      sort: "asc",
      width: 1,
    },
  ],
};
